export const categories = [
  {
    slug: 'rexue',
    name: '热血格斗',
    description: '充满激情与战斗的漫画作品，感受主角成长与突破极限的精彩故事',
    icon: 'ri-sword-line',
    imageSeq: 'cat-rexue-01',
  },
  {
    slug: 'lianai',
    name: '恋爱校园',
    description: '青春甜蜜的校园恋爱故事，记录懵懂心动的每一个瞬间',
    icon: 'ri-heart-line',
    imageSeq: 'cat-lianai-01',
  },
  {
    slug: 'xuanhuan',
    name: '玄幻奇幻',
    description: '宏大的异世界冒险，魔法、灵力与神秘力量的精彩碰撞',
    icon: 'ri-magic-line',
    imageSeq: 'cat-xuanhuan-01',
  },
  {
    slug: 'kehuan',
    name: '科幻未来',
    description: '探索未来科技与人类命运的深度作品，脑洞大开的科幻世界',
    icon: 'ri-rocket-line',
    imageSeq: 'cat-kehuan-01',
  },
  {
    slug: 'xuanyi',
    name: '悬疑推理',
    description: '环环相扣的推理故事，考验智慧的精彩谜题等你来解开',
    icon: 'ri-search-eye-line',
    imageSeq: 'cat-xuanyi-01',
  },
  {
    slug: 'gaoxiao',
    name: '搞笑日常',
    description: '轻松愉快的日常喜剧，让你在忙碌生活中找到欢乐与放松',
    icon: 'ri-emotion-laugh-line',
    imageSeq: 'cat-gaoxiao-01',
  },
  {
    slug: 'kongbu',
    name: '恐怖惊悚',
    description: '令人心跳加速的惊悚故事，挑战你的胆量与想象力',
    icon: 'ri-ghost-line',
    imageSeq: 'cat-kongbu-01',
  },
  {
    slug: 'lishi',
    name: '历史古风',
    description: '穿越时空的历史故事，感受古代文化的魅力与传奇',
    icon: 'ri-ancient-gate-line',
    imageSeq: 'cat-lishi-01',
  },
];

export const articles = [
  {
    id: 1,
    title: '禁漫天堂2026最新访问入口汇总 - 稳定高速不迷路',
    slug: 'latest-access-2026',
    excerpt: '本文汇总了禁漫天堂2026年所有可用的最新访问入口地址，包括主域名、备用域名及镜像站点，确保您随时随地都能稳定连接。',
    content: `<p>随着网络环境的不断变化，禁漫天堂的访问地址也会定期更新。为了让广大漫友能够稳定、快速地访问平台，我们整理了2026年最新的官方入口地址汇总。</p>
<h2>一、主域名入口</h2>
<p>禁漫天堂的主域名始终保持稳定运行，建议用户优先使用主域名访问。如遇访问异常，可尝试清除浏览器缓存或更换DNS服务器。</p>
<h2>二、备用域名</h2>
<p>当主域名因网络波动无法访问时，备用域名是最可靠的替代方案。我们建议您将备用域名收藏至浏览器书签栏。</p>
<h2>三、镜像站点</h2>
<p>禁漫天堂在全球多个地区部署了镜像站点，用户可根据所在地区选择最优节点，获得最佳的阅读体验。</p>
<h2>四、移动端访问</h2>
<p>使用手机浏览器的用户，建议开启"桌面版网站"模式以获得完整功能体验。同时推荐下载官方APP获得更流畅的阅读体验。</p>
<h2>五、常见访问问题</h2>
<p>如遇到页面加载缓慢或无法打开的情况，建议：1) 切换网络环境；2) 更换浏览器；3) 检查防火墙设置；4) 联系官方客服获取帮助。</p>`,
    category: 'rexue',
    imageSeq: 'article-access-01',
    date: '2026-08-01',
    readTime: '5分钟',
    tags: ['访问入口', '最新地址', '使用教程'],
  },
  {
    id: 2,
    title: '禁漫天堂新用户注册完整教程 - 三步搞定账号注册',
    slug: 'registration-tutorial',
    excerpt: '详细的禁漫天堂账号注册流程指南，从访问官网到完成注册，每一步都有清晰截图说明，帮助新用户快速上手。',
    content: `<p>欢迎加入禁漫天堂大家庭！本教程将手把手教你完成账号注册，整个过程仅需三分钟。</p>
<h2>第一步：访问官方网站</h2>
<p>使用浏览器打开禁漫天堂官方网站，点击页面右上角的"注册"按钮进入注册页面。</p>
<h2>第二步：填写注册信息</h2>
<p>在注册页面中，输入您的邮箱地址、设置密码，并填写昵称。请确保邮箱地址有效，以便接收验证邮件和找回密码。</p>
<h2>第三步：验证并完成注册</h2>
<p>提交注册信息后，系统会向您的邮箱发送验证邮件。点击邮件中的验证链接即可激活账号，完成注册流程。</p>
<h2>注册注意事项</h2>
<p>1. 密码建议包含字母、数字和特殊字符，长度不少于8位。2. 请使用真实有效的邮箱地址。3. 每个邮箱仅可注册一个账号。4. 注册即表示同意平台用户协议和隐私政策。</p>`,
    category: 'gaoxiao',
    imageSeq: 'article-register-01',
    date: '2026-08-03',
    readTime: '4分钟',
    tags: ['注册教程', '新手指南', '账号管理'],
  },
  {
    id: 3,
    title: '禁漫天堂内容分类全解析 - 八大类别总有一款适合你',
    slug: 'content-categories-guide',
    excerpt: '详细介绍禁漫天堂的八大内容分类体系，包括热血格斗、恋爱校园、玄幻奇幻等，帮你快速找到心仪的漫画作品。',
    content: `<p>禁漫天堂拥有丰富多样的漫画资源，为了方便用户浏览和发现感兴趣的内容，我们将所有作品分为八大类别。</p>
<h2>热血格斗类</h2>
<p>以激烈的战斗场面和主角成长为主线，代表作包括各类少年漫画。这类作品通常节奏明快、情节紧凑，适合喜欢动作场面的读者。</p>
<h2>恋爱校园类</h2>
<p>以校园生活为背景，讲述青春期的恋爱故事。画风清新唯美，情节温馨甜蜜，是放松心情的绝佳选择。</p>
<h2>玄幻奇幻类</h2>
<p>构建于架空世界之上，包含魔法、灵力、异世界等元素。世界观宏大，想象力丰富，能够带给读者完全不同的阅读体验。</p>
<h2>更多分类</h2>
<p>此外还有科幻未来、悬疑推理、搞笑日常、恐怖惊悚和历史古风等多个分类，每个分类下都有大量优质作品等待你的发现。</p>`,
    category: 'xuanhuan',
    imageSeq: 'article-category-01',
    date: '2026-08-05',
    readTime: '6分钟',
    tags: ['内容分类', '漫画类型', '阅读指南'],
  },
  {
    id: 4,
    title: '禁漫天堂APP下载与安装指南 - iOS和Android全覆盖',
    slug: 'app-download-guide',
    excerpt: '禁漫天堂官方APP下载教程，支持iOS和Android双平台，提供APK直接下载和应用商店安装两种方式。',
    content: `<p>禁漫天堂官方APP为移动端用户提供了更加流畅便捷的漫画阅读体验。以下是详细的下载与安装指南。</p>
<h2>Android用户</h2>
<p>方式一：访问禁漫天堂官网，在首页找到"APP下载"入口，下载最新版APK安装包。安装前请在手机设置中允许"安装未知来源应用"。方式二：在官方合作应用商店搜索"禁漫天堂"下载安装。</p>
<h2>iOS用户</h2>
<p>iOS用户可通过TestFlight参与测试版本，或访问官网使用Web App版本。Web App支持添加到主屏幕，体验接近原生应用。</p>
<h2>APP特色功能</h2>
<p>1. 离线下载：支持将漫画缓存至本地，无网络也能畅快阅读。2. 阅读进度同步：登录账号后自动同步多设备阅读进度。3. 推送提醒：收藏作品更新时第一时间收到通知。4. 夜间模式：保护视力，黑暗环境中也能舒适阅读。</p>`,
    category: 'kehuan',
    imageSeq: 'article-app-01',
    date: '2026-08-07',
    readTime: '5分钟',
    tags: ['APP下载', '移动端', '安装教程'],
  },
  {
    id: 5,
    title: '禁漫天堂阅读功能深度体验 - 打造极致漫画阅读享受',
    slug: 'reading-features',
    excerpt: '全面解析禁漫天堂的阅读功能设计，从翻页模式到画质调节，每一个细节都经过精心打磨，只为给你最好的阅读体验。',
    content: `<p>禁漫天堂在阅读体验方面投入了大量精力，致力于为漫友打造极致的漫画阅读享受。</p>
<h2>多种翻页模式</h2>
<p>支持左右翻页、上下滚动、卷轴模式等多种阅读方式，用户可根据个人习惯自由选择。日式漫画推荐使用从右向左的翻页模式，完美还原纸质漫画的阅读体验。</p>
<h2>智能画质调节</h2>
<p>系统会根据网络环境自动调节图片加载质量，同时支持手动切换高清/超清模式。WiFi环境下推荐使用超清画质，获得最佳视觉享受。</p>
<h2>个性化阅读设置</h2>
<p>支持亮度调节、背景色切换、屏幕方向锁定等功能。夜间阅读时可开启护眼模式，减少蓝光对眼睛的伤害。</p>
<h2>书签与历史记录</h2>
<p>自动保存阅读历史，支持手动添加书签。即使更换设备，登录账号后也能无缝衔接上一次的阅读进度。</p>`,
    category: 'xuanyi',
    imageSeq: 'article-reading-01',
    date: '2026-08-06',
    readTime: '6分钟',
    tags: ['阅读功能', '用户体验', '功能指南'],
  },
  {
    id: 6,
    title: '禁漫天堂社区互动指南 - 与百万漫友一起交流分享',
    slug: 'community-guide',
    excerpt: '了解禁漫天堂的社区功能，包括评论互动、作品评分、漫友关注和兴趣圈子，让你的漫画之旅不再孤单。',
    content: `<p>禁漫天堂不仅是一个漫画阅读平台，更是一个充满活力的漫友社区。在这里，你可以与来自世界各地的漫画爱好者交流分享。</p>
<h2>评论区互动</h2>
<p>每部漫画作品下方都设有评论区，你可以发表自己的阅读感受，与其他读者讨论剧情发展，分享追漫心得。</p>
<h2>作品评分系统</h2>
<p>通过五星评分系统为你喜欢的作品打分，高评分作品会获得更多曝光机会，帮助更多漫友发现优质内容。</p>
<h2>兴趣圈子</h2>
<p>加入你感兴趣的主题圈子，与志同道合的漫友深入交流。无论是特定作品讨论还是创作技巧分享，都能找到属于你的圈子。</p>
<h2>漫友关注</h2>
<p>关注你欣赏的漫友，及时了解他们的最新动态和推荐。建立自己的漫友圈，让漫画阅读成为社交的一部分。</p>`,
    category: 'lianai',
    imageSeq: 'article-community-01',
    date: '2026-08-04',
    readTime: '5分钟',
    tags: ['社区互动', '漫友交流', '社交功能'],
  },
  {
    id: 7,
    title: '禁漫天堂账号安全防护指南 - 保护你的数字资产',
    slug: 'account-security',
    excerpt: '详细的安全设置教程，包括密码管理、二次验证、登录设备管理和异常登录提醒，全方位守护你的账号安全。',
    content: `<p>账号安全是每位用户都应重视的问题。禁漫天堂提供了完善的安全防护体系，以下是详细的安全设置指南。</p>
<h2>强密码设置</h2>
<p>建议使用包含大小写字母、数字和特殊字符的复杂密码，长度不少于12位。避免使用生日、手机号等容易被猜测的信息作为密码。</p>
<h2>二次验证</h2>
<p>开启二次验证功能后，每次登录都需要输入手机验证码或使用认证器应用生成的一次性验证码，大大提升账号安全性。</p>
<h2>登录设备管理</h2>
<p>在安全中心可以查看所有登录过的设备记录，如发现可疑设备可立即下线并修改密码。</p>
<h2>异常登录提醒</h2>
<p>当系统检测到异常登录行为时，会立即通过邮件和短信向您发送安全提醒，确保您第一时间知晓账号动态。</p>`,
    category: 'kongbu',
    imageSeq: 'article-security-01',
    date: '2026-07-30',
    readTime: '4分钟',
    tags: ['账号安全', '安全设置', '使用指南'],
  },
  {
    id: 8,
    title: '禁漫天堂VIP会员权益详解 - 解锁尊享体验',
    slug: 'vip-benefits',
    excerpt: '全面了解禁漫天堂VIP会员的各项专属权益，包括无广告阅读、高清画质、提前观看和专属客服等。',
    content: `<p>禁漫天堂VIP会员为用户提供了一系列专属权益，让漫画阅读体验更上一层楼。</p>
<h2>无广告纯净阅读</h2>
<p>VIP会员享受全平台无广告的纯净阅读体验，彻底告别弹窗和插屏广告的干扰，沉浸在漫画世界中。</p>
<h2>超清画质特权</h2>
<p>解锁全部作品的超清画质选项，每一页漫画都纤毫毕现，细节清晰可见，带来极致的视觉享受。</p>
<h2>提前观看权益</h2>
<p>热门连载作品VIP会员可提前24小时观看最新章节，永远走在追漫的最前沿。</p>
<h2>专属客服通道</h2>
<p>VIP会员拥有专属客服通道，问题反馈优先处理，享受一对一的贴心服务。</p>`,
    category: 'rexue',
    imageSeq: 'article-vip-01',
    date: '2026-07-28',
    readTime: '5分钟',
    tags: ['VIP会员', '会员权益', '付费服务'],
  },
  {
    id: 9,
    title: '禁漫天堂常见问题解答 - 你想知道的都在这里',
    slug: 'faq-collection',
    excerpt: '收集整理了禁漫天堂用户最常遇到的问题及解答，涵盖访问、注册、阅读、付费等各个方面。',
    content: `<p>我们整理了用户在使用禁漫天堂过程中最常遇到的问题，希望能够帮助您快速解决疑惑。</p>
<h2>访问相关</h2>
<p>Q: 为什么有时候打不开网站？A: 可能是网络波动或DNS解析问题，建议尝试更换网络环境或使用备用域名访问。</p>
<h2>注册相关</h2>
<p>Q: 注册后没有收到验证邮件？A: 请检查垃圾邮件箱，或将禁漫天堂的邮箱地址添加至白名单后重新发送验证邮件。</p>
<h2>阅读相关</h2>
<p>Q: 漫画加载很慢怎么办？A: 建议切换至标清画质，或在WiFi环境下预加载章节内容。</p>
<h2>付费相关</h2>
<p>Q: VIP到期后已下载的内容还能看吗？A: VIP期间下载的内容在会员到期后将无法查看，需要续费VIP或单独购买相应章节。</p>`,
    category: 'lishi',
    imageSeq: 'article-faq-01',
    date: '2026-07-25',
    readTime: '7分钟',
    tags: ['常见问题', 'FAQ', '帮助中心'],
  },
  {
    id: 10,
    title: '2026年最值得追的十部热血漫画推荐',
    slug: 'top-10-hot-blood-manga-2026',
    excerpt: '精心筛选2026年禁漫天堂上最受好评的十部热血格斗类漫画，每一部都值得你投入时间追更。',
    content: `<p>2026年禁漫天堂上涌现了大量优秀的热血格斗类漫画作品，我们从中精选了十部最值得追更的作品推荐给大家。</p>
<h2>精选推荐</h2>
<p>以下推荐作品在剧情、画风和人气方面均表现出色，无论是新入坑的漫友还是资深读者都能从中找到喜欢的作品。每部作品都拥有独特的世界观和精彩的战斗设计，绝对不容错过。</p>
<h2>如何选择</h2>
<p>如果你是热血漫画的新读者，建议从完结作品开始阅读，避免追更等待的煎熬。资深读者则可以根据作品更新频率和评分来选择最适合自己节奏的连载作品。</p>`,
    category: 'rexue',
    imageSeq: 'article-top10-01',
    date: '2026-08-08',
    readTime: '8分钟',
    tags: ['漫画推荐', '热血格斗', '排行榜'],
  },
];

export const faqList = [
  {
    question: '禁漫天堂是否需要付费？',
    answer: '禁漫天堂提供免费和付费两种阅读模式。大部分漫画可以免费阅读，部分热门作品的最新章节和VIP专属内容需要订阅会员或单独购买。VIP会员还享有无广告、超清画质和提前观看等专属权益。',
  },
  {
    question: '如何找到禁漫天堂的最新访问地址？',
    answer: '您可以通过以下方式获取最新地址：1) 关注禁漫天堂官方社交媒体账号获取实时更新；2) 将本页面添加至收藏夹；3) 加入官方用户交流群获取最新通知。我们建议同时保存主域名和备用域名。',
  },
  {
    question: '禁漫天堂的APP在哪里下载？',
    answer: 'Android用户可在禁漫天堂官网首页找到APP下载入口，直接下载APK安装包。iOS用户可通过TestFlight参与测试，或使用Web App版本并添加到主屏幕。请务必从官方渠道下载，避免安全风险。',
  },
  {
    question: '忘记账号密码怎么办？',
    answer: '在登录页面点击"忘记密码"，输入注册时使用的邮箱地址，系统会发送密码重置链接到您的邮箱。点击链接即可设置新密码。如果收不到邮件，请检查垃圾邮件箱或联系客服。',
  },
  {
    question: '可以在多个设备上同时登录吗？',
    answer: '可以。禁漫天堂支持在多个设备上同时登录同一账号，阅读进度和收藏内容会自动同步。但为了保护账号安全，建议不要在公共设备上保存登录状态。',
  },
  {
    question: '下载的漫画可以离线阅读吗？',
    answer: '可以。禁漫天堂APP支持离线下载功能，VIP会员可以将漫画章节缓存至本地存储，在没有网络的情况下也能畅快阅读。普通用户有每日下载数量限制。',
  },
  {
    question: '如何联系禁漫天堂客服？',
    answer: '您可以通过以下方式联系我们的客服团队：1) 在官网"关于我们"页面使用在线联系表单；2) 发送邮件至官方客服邮箱；3) 在APP内使用"帮助与反馈"功能。VIP会员享有专属客服通道。',
  },
  {
    question: '禁漫天堂支持哪些阅读模式？',
    answer: '禁漫天堂支持多种阅读模式：左右翻页（模拟纸质漫画）、上下滚动（适合手机阅读）、卷轴模式（连续阅读）以及自动翻页模式。日式漫画还支持从右向左的翻页方向，您可以在阅读设置中自由切换。',
  },
];

export const testimonials = [
  {
    id: 1,
    name: '漫画达人小明',
    avatar: '',
    rating: 5,
    content: '使用禁漫天堂已经三年了，资源更新速度非常快，画质也很棒。分类体系很完善，找漫画特别方便，是我用过最好的漫画平台。',
    date: '2026-07-20',
  },
  {
    id: 2,
    name: '追漫少女莉莉',
    avatar: '',
    rating: 5,
    content: 'APP的离线下载功能太实用了！坐地铁通勤的时候也可以看漫画，不消耗流量。推荐给了很多朋友，大家都说好用。',
    date: '2026-07-15',
  },
  {
    id: 3,
    name: '资深漫评人老张',
    avatar: '',
    rating: 5,
    content: '作为一个看了二十年漫画的老读者，禁漫天堂无论是资源丰富程度还是阅读体验都让我非常满意。社区的讨论氛围也很好。',
    date: '2026-07-10',
  },
  {
    id: 4,
    name: '二次元爱好者阿伟',
    avatar: '',
    rating: 4,
    content: '界面设计很清爽，没有乱七八糟的广告干扰。收藏功能很方便，追更的漫画更新了会第一时间通知，再也不会错过更新了。',
    date: '2026-07-05',
  },
  {
    id: 5,
    name: '学生党小陈',
    avatar: '',
    rating: 5,
    content: '免费内容非常多，对于学生党来说太友好了。阅读进度跨设备同步功能也很好用，手机和平板无缝切换。',
    date: '2026-06-28',
  },
  {
    id: 6,
    name: '上班族大刘',
    avatar: '',
    rating: 5,
    content: '午休时间看几话漫画已经成为习惯了。禁漫天堂的推荐算法很精准，经常能发现一些冷门但质量很高的作品。VIP性价比很高。',
    date: '2026-06-20',
  },
];